var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9 12H19.2L12 19.2L4.80005 12H11.1V4.80005H12.9V12Z",
    fill: "#E91429"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownRed);
export default __webpack_public_path__ + "static/media/arrow-down-red.2d21190ef6de76c65bc6084b92a6a4a7.svg";
export { ForwardRef as ReactComponent };